import { api } from "@/lib/api";

/**
 * Upload a File (image or video) to Cloudinary via signed upload.
 * folder: "profiles/" | "verifications/"
 * resource_type: "image" | "video"
 * anonymous: if true, use the public signature endpoint (for pre-registration uploads)
 * Returns { secure_url, public_id } on success.
 */
export async function uploadToCloudinary(file, folder = "profiles/", resource_type = "image", anonymous = false) {
  if (!file) throw new Error("Archivo vacío");

  const isVideo = resource_type === "video";
  const maxMB = isVideo ? 100 : 10;
  if (file.size > maxMB * 1024 * 1024) throw new Error(`Archivo supera ${maxMB} MB`);

  const okImage = ["image/jpeg", "image/png", "image/webp"];
  const okVideo = ["video/mp4", "video/quicktime", "video/webm"];
  const allowed = isVideo ? okVideo : okImage;
  if (!allowed.includes(file.type)) {
    throw new Error(isVideo ? "Solo MP4, MOV o WEBM" : "Solo JPG, PNG o WEBP");
  }

  const sigEndpoint = anonymous ? "/upload/signature/public" : "/upload/signature";
  const sigParams = anonymous ? {} : { params: { folder } };
  const { data: sig } = await api.get(sigEndpoint, sigParams);

  const form = new FormData();
  form.append("file", file);
  form.append("api_key", sig.api_key);
  form.append("timestamp", sig.timestamp);
  form.append("signature", sig.signature);
  form.append("folder", sig.folder);

  const endpoint = `https://api.cloudinary.com/v1_1/${sig.cloud_name}/${resource_type}/upload`;
  const res = await fetch(endpoint, { method: "POST", body: form });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err?.error?.message || "Error al subir a Cloudinary");
  }
  const json = await res.json();
  return { secure_url: json.secure_url, public_id: json.public_id };
}
